import {
  Card,
  CardBody,
  Input,
  TableRow,
  Table,
  TableCell,
  TableContainer,
  TableHeader,
  Button,
} from "@windmill/react-ui";
import ExportDataXlsx from "components/common/ExportDataXlsx";
import AirportPickupBasicRateTable from "components/airportPickupBasicRate/AirportPickupBasicRateTable";
import DataWrapper from "./DataWrapper";
import NotFound from "components/table/NotFound";
import PageTitle from "components/Typography/PageTitle";
import { SidebarContext } from "context/SidebarContext";
import Somethingwentwrong from "pages/Somethingwentwrong";
import useAsync from "hooks/useAsync";
import useFilter from "hooks/useFilter";
import { useState, useContext, useEffect } from "react";
import AirportPickupBasicRateServices from "services/AirportPickupBasicRateServices";
import { FiPlus } from "react-icons/fi";
import AirportPickupBasicRateDrawer from "components/drawer/AirportPickupBasicRateDrawer";
import MainDrawer from "components/drawer/MainDrawer";
import DeleteModal from "components/modal/DeleteModal";
import useToggleDrawer from "hooks/useToggleDrawer";
import sidebar from "routes/sidebar";

const AirportPickupBasicRate = () => {
  const adminInfo = localStorage.getItem("adminInfo")
    ? JSON.parse(localStorage.getItem("adminInfo"))
    : null;
  const { toggleDrawer } = useContext(SidebarContext);
  const { title, serviceId } = useToggleDrawer();
  const [status, setStatus] = useState("");
  const { data, loading, error } = useAsync(
    AirportPickupBasicRateServices.getAllAirportPickupBasicRate,
  );

  const isDataArray = Array.isArray(data?.data); // Check if data is an array
  const safeData = isDataArray ? data?.data : []; // Use empty array if data is not an array

  const isAdmin = adminInfo?.id === 1;

  const hideView = adminInfo?.permission?.some(
    (perm) => perm.id_tab === "airport basic rate" && perm.view === 1,
  );

  const hideDelete = adminInfo?.permission?.some(
    (perm) => perm.id_tab === "airport basic rate" && perm.delete === 1,
  );

  const hideEdit = adminInfo?.permission?.some(
    (perm) => perm.id_tab === "airport basic rate" && perm.edit === 1,
  );

  const hideAdd = adminInfo?.permission?.some(
    (perm) => perm.id_tab === "airport basic rate" && perm.add === 1,
  );

  const hideExport = adminInfo?.permission?.some(
    (perm) => perm.id_tab === "airport basic rate" && perm.export === 1,
  );
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const {
    airportPickupBasicRateRef,
    dataTable,
    serviceData,
    handleSubmitAirportPickupBasicRate,
    currentPage,
  } = useFilter(Array.isArray(data?.data) ? data?.data : [], itemsPerPage);
  useEffect(() => {
    if (serviceData.length !== 0) {
      setItemsPerPage(serviceData.length);
    }
  }, [serviceData]);
  const updatedData = safeData.map(({ id, ...rest }) => rest);
  // console.log("airport picup basicrate", updatedData);

  useEffect(() => {
    if (data?.status) {
      setStatus(data.status);
    } else {
      setStatus(false);
    }
  }, [data?.status]);

  const finalData = [];

  data?.data?.forEach((item, itemIndex) => {
    const vehicleIds = item.vehicle_type_id || [];
    const vehicleNames = item.vehicle_type_names || {};

    vehicleIds.forEach((vid, vehicleIndex) => {
      const isFirstVehicle = vehicleIndex === 0;
      const primeValue = item.prime?.[vid];

      finalData.push({
        // Airport details — first vehicle row only
        "S.No.": isFirstVehicle ? itemIndex + 1 : "",
        ID: isFirstVehicle ? (item.id ?? "") : "",

        "State ID": isFirstVehicle ? (item.state_id ?? "") : "",
        State: isFirstVehicle ? (item.state_name ?? "") : "",

        "City ID": isFirstVehicle ? (item.city_id ?? "") : "",
        City: isFirstVehicle ? (item.city_name ?? "") : "",

        "Airport ID": isFirstVehicle ? (item.airport_id ?? "") : "",
        "Airport Code": isFirstVehicle ? (item.airport_code ?? "") : "",
        Airport: isFirstVehicle ? (item.name_of_airport ?? "") : "",

        // Vehicle details
        "Vehicle ID": vid,
        "Vehicle Type": vehicleNames[vid] || vid,

        // Airport pickup rates
        "Min KM": item.min_km?.[vid] ?? "",
        "Min Rate": item.min_rate?.[vid] ?? "",
        "Extra KM": item.extra_km?.[vid] ?? "",

        // Prime percentage
        Prime:
          primeValue !== undefined && primeValue !== null && primeValue !== ""
            ? `${primeValue}%`
            : "",

        // Status — first vehicle row only
        Status: isFirstVehicle
          ? item.is_active == 0
            ? "Inactive"
            : "Active"
          : "",
      });
    });
  });

  return (
    <>
      {hideView && (
        <>
          <DeleteModal id={serviceId} title={title} />

          <MainDrawer>
            <AirportPickupBasicRateDrawer id={serviceId} />
          </MainDrawer>

          <PageTitle sidebar={sidebar().sidebar} />

          <Card className="min-w-0 shadow-xs overflow-hidden bg-white dark:bg-gray-800 mb-5">
            <CardBody>
              <div className="flex gap-6 items-center">
                <div className="flex-1">
                  <Input
                    ref={airportPickupBasicRateRef}
                    className="border h-10 text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
                    type="search"
                    name="search"
                    placeholder="Quick Search"
                    autoComplete="off"
                    onChange={handleSubmitAirportPickupBasicRate}
                  />
                </div>

                {hideAdd && (
                  <Button
                    onClick={toggleDrawer}
                    className="w-56 rounded-md h-10"
                  >
                    <span className="mr-3">
                      <FiPlus />
                    </span>
                    Add Airport Pickup Rate
                  </Button>
                )}

                {hideExport && (
                  <ExportDataXlsx
                    exportDataXlsx={finalData}
                    fileNames="Airport Pickup Basic Rate"
                  />
                )}
              </div>
            </CardBody>
          </Card>

          <DataWrapper loading={loading} error={error} status={status}>
            {serviceData.length ? (
              <TableContainer className="mb-8">
                <div
                  className="overflow-y-scroll"
                  style={{ maxHeight: "65vh", scrollbarWidth: "thin" }}
                >
                  <Table>
                    <TableHeader className="custom-table-header capitalize z-10 text-center sticky top-0 text-sm">
                      <TableRow>
                        <TableCell>Sl.No.</TableCell>
                        <TableCell>Airport</TableCell>
                        <TableCell>Vehicle Type</TableCell>
                        <TableCell>Min Rate</TableCell>
                        <TableCell>Min KM</TableCell>
                        <TableCell>Extra KM</TableCell>
                        <TableCell>Prime</TableCell>
                        <TableCell>Status</TableCell>
                        <TableCell>Actions</TableCell>
                      </TableRow>
                    </TableHeader>
                    <AirportPickupBasicRateTable
                      airportPickupBasicRate={dataTable}
                      perpage={itemsPerPage}
                      currentPage={currentPage}
                      hideDelete={hideDelete}
                      hideEdit={hideEdit}
                    />
                  </Table>
                </div>
              </TableContainer>
            ) : (
              <>
                {data.status !== true ? (
                  <Somethingwentwrong title="Something Went Wrong, Try After Sometime" />
                ) : (
                  <NotFound title="There are no Airport Pickup Basic Rates." />
                )}
              </>
            )}
          </DataWrapper>
        </>
      )}
    </>
  );
};

export default AirportPickupBasicRate;
